import { ComponentType } from 'react';
import { FeatureFlag } from '@synergy/models';

import { AccessControl } from './access-control';

export const AccessControlConnectFeature =
    (feature?: FeatureFlag, redirect = false) =>
    <P extends object>(WrappedComponent: ComponentType<P>) =>
    (props: P) =>
        (
            <AccessControl allowedFeature={feature} redirect={redirect}>
                <WrappedComponent {...props} />
            </AccessControl>
        );
